module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-900.260c2ea3ef57feb82251952e605a36d5.woff2";